import { createFileRoute } from '@tanstack/react-router'
import { AccountShell } from '@/features/account/account-shell'

export const Route = createFileRoute('/_authenticated/account')({
  component: AccountShell,
})
